import { render, staticRenderFns } from "./AlldateEchats.vue?vue&type=template&id=28e5d177&scoped=true&"
import script from "./AlldateEchats.vue?vue&type=script&lang=js&"
export * from "./AlldateEchats.vue?vue&type=script&lang=js&"
import style0 from "./AlldateEchats.vue?vue&type=style&index=0&id=28e5d177&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5d177",
  null
  
)

export default component.exports